import styled from 'styled-components';
import { nuDSColor, spacing } from '@nubank/nuds-web/styles/themeUtils';

export const ExperimentsWidgetWrapper = styled.div`
  position: fixed;
  right: ${spacing('4x')};
  bottom: ${spacing('0x')};
  background: ${nuDSColor('black')};
  border-radius: ${spacing('1x')};
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  z-index: 3002;
  transition: opacity .2s ease-out;
  max-width: 328px;
`;
